orders-planner-on-orders-show
  orders-planner-date-ui(tag-scope="orders_planner_date_ui")
  orders-planner-lines(tag-scope="{dataScopeOrder(opts.order_id)}" data-edit="{this.opts.dataEdit}")
  orders-planner-task-editor(if="{this.opts.dataEdit}" tag-scope="orders_planner_task_editor" order-id="{opts.order_id}")
  orders-planner-dialog-tooltip-schedule(tag-scope="orders_planner_dialog_tooltip_schedule")
  orders-planner-dialog-save-tasks-memo(if="{this.opts.dataEdit}" tag-scope="orders_planner_dialog_save_tasks_memo")
  orders-planner-dialog-create-schedule(if="{this.opts.dataEdit}" tag-scope="orders_planner_dialog_create_schedule")
  orders-planner-dialog-line-menu(if="{this.opts.dataEdit}" tag-scope="orders_planner_dialog_line_menu")
  forms-schedules-update(if="{this.opts.dataEdit}" tag-scope="forms_schedules_update")
  forms-schedules-destroy(if="{this.opts.dataEdit}" tag-scope="forms_schedules_destroy")
  orders-planner-scroll(tag-scope="{orders_planner}")
  script(type="typescript").
    this.mixin('orders.planner.one');
